export const hasRequestableExceptionIssues = (validation) =>
  (validation?.exception_issues ?? []).length > 0;

export const shouldHideRequestExceptionsButton = ({
  isExpenseAccountOwner,
  canRequestExceptions,
  hasRequestableExceptions,
}) => !isExpenseAccountOwner || !canRequestExceptions || !hasRequestableExceptions;
